import { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
// cmp
import Na from "../na";
// services
import type { GridColDef, GridRowIdGetter } from "@mui/x-data-grid";
import type { FirmwareInfos, FirmwareInfo } from "../../types/gupport";

const UPDATE_STATUS = {
	update: "UPDATED",
	noupdate: "NO UPDATE AVAILABLE",
	error: "ERROR",
} as const;

const handleGetRowId: GridRowIdGetter<FirmwareInfo> = (row) => (row.name);

type Props = Readonly<{
	updatedFirmwareInfos?: FirmwareInfos;
}>;

const DEFAULT_UPDATED_FIRMWARE_INFOS = [] as const satisfies FirmwareInfos;

const UpdatedFirmwareInfo = ({ updatedFirmwareInfos = DEFAULT_UPDATED_FIRMWARE_INFOS }: Props) => {
	const { t } = useTranslation();

	const columns = useMemo(() => ([
		{
			field: "name",
			headerName: t("gateway.plugin"),
			flex: 1,
		},
		{
			field: "status",
			headerName: t("gateway.updatedStatus"),
			flex: 1,
			renderCell: (params) => (UPDATE_STATUS[params.value] ?? <Na />),
		},
		{
			field: "version",
			headerName: t("gateway.currentVersion"),
			flex: 1,
			renderCell: (params) => (params.value ?? <Na />),
		},
	] as const satisfies ReadonlyArray<GridColDef<FirmwareInfo>>), [t]);

	return (
		<DataGrid
			columns={columns}
			rows={updatedFirmwareInfos}
			getRowId={handleGetRowId}
		/>
	);
};

export default UpdatedFirmwareInfo;
